import { useEffect, useState } from "react"
import Header from "../components/common/Header"
import Sidebar from "../components/common/Sidebar"
import Loader from "../components/subComponents/Loader"

const AdminLayout = ({ children }: { children: React.ReactNode }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)

  useEffect(() => {
    const screenWidth = window.innerWidth
    if (screenWidth < 1024) {
      setIsSidebarOpen(false) // Collapse on small screens
    }
  }, [])

  return (
    <div className='flex'>
      <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />

      <main
        className={`main-content ${isSidebarOpen ? "main-content-open" : "main-content-closed"}`}
      >
        <Loader />
        <Header isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
        {children}
      </main>
    </div>
  )
}

export default AdminLayout
